module.exports = __webpack_public_path__ + "BI.png?9d7f420f9a21f8dbdecf2050dad66edc";